<template>
  <div>
      <v-dialog :value="visible" width="500" persistent>
        <v-card>
          <v-card-title class="text-h6">Ändra lösenord</v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-text-field
                label="Nuvarande lösenord"
                outlined
                :rules="[rules.required]"
                v-model="currentPassword"
                :type="showCurrentPassword ? 'text' : 'password'"
                :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showCurrentPassword = !showCurrentPassword"
              ></v-text-field>
              <v-text-field
                label="Nytt lösenord"
                outlined
                :rules="[rules.required]"
                v-model="newPassword"
                :type="showNewPassword ? 'text' : 'password'"
                :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showNewPassword = !showNewPassword"
              ></v-text-field>
              <v-text-field
                label="Upprepa nytt lösenord"
                :rules="[rules.required, matchingPasswords]"
                outlined
                v-model="newPasswordRepeat"
                :type="showNewPasswordRepeat ? 'text' : 'password'"
                :append-icon="showNewPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showNewPasswordRepeat = !showNewPasswordRepeat"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="onClose"> Avbryt </v-btn>
            <v-btn color="primary" :loading="loading" :disabled="!canSubmit" @click="onSave">
              Spara
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <Message ref="message" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Message from '@/components/shared/Message'

export default {
  name: 'UserChangePassword',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Message,
  },

  data: () => ({
    loading: false,
    showCurrentPassword: false,
    showNewPassword: false,
    showNewPasswordRepeat: false,
    currentPassword: '',
    newPassword: '',
    newPasswordRepeat: '',
    rules: {
      required: (value) => !!value || 'Obligatoriskt',
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Ogiltig e-mail.'
      },
    },
  }),
  computed: {
    ...mapGetters('auth', { getCurrentUserId: 'currentUserId' }),
    canSubmit() {
      return (
        this.currentPassword &&
        this.newPassword &&
        this.newPasswordRepeat &&
        this.newPassword === this.newPasswordRepeat
      )
    },
  },
  methods: {
    ...mapActions('auth', { updatePassword:'updatePassword' }),
    matchingPasswords() {
      if (this.newPassword === this.newPasswordRepeat) {
        return true
      } else {
        return 'Lösenorden är inte lika.'
      }
    },
    onClear() {
      this.$refs.form.reset()
      this.showCurrentPassword = false
      this.showNewPassword = false
      this.showNewPasswordRepeat = false
      this.currentPassword = ''
      this.newPassword = ''
      this.newPasswordRepeat = ''
    },
    onClose() {
      this.$emit('close')
      this.onClear()
    },
    async onSave() {
      this.loading = true
      const requestPasswordChange = {
        id: this.getCurrentUserId,
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
        newPasswordRepeat: this.newPasswordRepeat,
      }
      await this.updatePassword(requestPasswordChange)
      this.loading = false
      this.$refs.message.open('Lösenord bytt')
      this.onClose()
    },
  },
}
</script>

<style lang="less" scoped></style>
